// extracted by mini-css-extract-plugin
export default {"badge":"NewBadge_badge__VgkJX"};